import events from 'events.js';
import ko from 'knockout';
import query from 'query.js';
import SearchManager from 'search/search.js';

(async function() {
    await events.ready();
    const mgr = new SearchManager();
    mgr.isSearchResults(true);
    const filterType = query.parse().filter || '';
    mgr.autoSetQuery = true;
    const q = decodeURIComponent((query.parse().q || '').replace(/\+/g, ' '));
    await mgr.search(q, true);
    mgr.typedQuery(q);
    const filter = mgr.filters().find((f) => f.type === filterType);
    if (filter) {
        mgr.currentFilter(filter);
    }
    mgr.elems.push(document.getElementById('search-area'));
    mgr.elems.push(document.getElementById('search-title'));
    ko.applyBindings(mgr, document.getElementById('search-area'));
    ko.applyBindings(mgr, document.getElementById('search-title'));
    ko.applyBindings(mgr, document.getElementsByClassName('js-query')[0]);
})();
